module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    attrs: {
      "id": "default-templates"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'languages-area'),
      expression: "activeTab == 'languages-area'"
    }],
    staticClass: "languages-area"
  }, [_c('div', {
    staticClass: "translations-title-section"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('account.settings.message_templates_section.translations')))])]), _vm._v(" "), _c('div', {
    staticClass: "languages"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', {
    staticClass: "lang"
  }, [_vm._v(_vm._s(_vm.$t('account.settings.message_templates_section.english')))]), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeTab('templates-area-en')
      }
    }
  }, [_c('i', {
    staticClass: "far fa-edit"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "lang"
  }, [_vm._v(_vm._s(_vm.$t('account.settings.message_templates_section.french')))]), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeTab('templates-area-fr')
      }
    }
  }, [_c('i', {
    staticClass: "far fa-edit"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "lang"
  }, [_vm._v(_vm._s(_vm.$t('account.settings.message_templates_section.portugal')))]), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeTab('templates-area-pt')
      }
    }
  }, [_c('i', {
    staticClass: "far fa-edit"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "lang"
  }, [_vm._v(_vm._s(_vm.$t('account.settings.message_templates_section.spanish')))]), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeTab('templates-area-es')
      }
    }
  }, [_c('i', {
    staticClass: "far fa-edit"
  })])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'templates-area-en' || _vm.activeTab == 'templates-area-fr' || _vm.activeTab == 'templates-area-pt' || _vm.activeTab == 'templates-area-es'),
      expression: "activeTab == 'templates-area-en' || activeTab == 'templates-area-fr' || activeTab == 'templates-area-pt' || activeTab == 'templates-area-es'"
    }],
    staticClass: "templates-area"
  }, [_c('div', {
    staticClass: "translations-title-section"
  }, [_c('h1', [_vm._v(_vm._s(_vm.activeTab == 'templates-area-en' ? _vm.$t('account.settings.message_templates_section.edit_english') : _vm.activeTab == 'templates-area-fr' ? _vm.$t('account.settings.message_templates_section.edit_french') :
    _vm.activeTab == 'templates-area-pt' ? _vm.$t('account.settings.message_templates_section.edit_portugal') : _vm.$t('account.settings.message_templates_section.edit_spanish')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "templates"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.templates), function(template) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeTab == 'templates-area-en' ? (template.lang == 'en') : _vm.activeTab == 'templates-area-fr' ? (template.lang == 'fr') :
          _vm.activeTab == 'templates-area-pt' ? (template.lang == 'pt') : (template.lang == 'es')),
        expression: "activeTab == 'templates-area-en' ? (template.lang == 'en') : activeTab == 'templates-area-fr' ? (template.lang == 'fr') :\n                    activeTab == 'templates-area-pt' ? (template.lang == 'pt') : (template.lang == 'es')"
      }],
      staticClass: "list-group-item"
    }, [_c('a', {
      staticClass: "list-group-item-action",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeCurrentTemplate(template.name, _vm.activeTab.slice(-2))
        }
      }
    }, [_c('i', {
      class: _vm.currentTemplate.name == template.name ? 'fa fa-caret-down' : 'fa fa-caret-right'
    }), _vm._v("  " + _vm._s(_vm.getTitleTranslations(template.name)) + " ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentTemplate.name == template.name),
        expression: "currentTemplate.name == template.name"
      }],
      staticClass: "template-body"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xl-3"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xl-9"
    }, [(_vm.currentTemplate.name != 'Send superconcierge invoice') ? _c('button', {
      staticClass: "btn btn-primary btn-cons shortcodes",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openShortcodeListModal('#shortcode-list-modal')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.show_shortcode_list")))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group row subject"
    }, [_c('label', {
      staticClass: "col-xl-2 col-lg-2",
      attrs: {
        "for": 'msgsubject' + template.id
      }
    }, [_vm._v(_vm._s(_vm.$t('account.settings.message_templates_section.subject')))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-9 col-lg-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentTemplate.subject),
        expression: "currentTemplate.subject"
      }],
      ref: 'templateSubject' + template.id,
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": 'msgsubject' + template.id
      },
      domProps: {
        "value": (_vm.currentTemplate.subject)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.focused('templateSubject' + template.id, 'subject')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.currentTemplate, "subject", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "form-group row body"
    }, [_c('label', {
      staticClass: "col-xl-2 col-lg-3",
      attrs: {
        "for": 'msgbody' + template.id
      }
    }, [_vm._v(_vm._s(_vm.$t('account.settings.message_templates_section.body')))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-8 col-lg-4"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentTemplate.context),
        expression: "currentTemplate.context"
      }],
      ref: 'templateBody' + template.id,
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "id": 'msgbody' + template.id
      },
      domProps: {
        "value": (_vm.currentTemplate.context)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.focused('templateBody' + template.id, 'context')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.currentTemplate, "context", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-cons",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.updateTemplate(_vm.currentTemplate)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('button.save')))])])])])])
  })), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-go-back",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeTab('languages-area')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])]), _vm._v(" "), _c('VShortCodeListModal', {
    attrs: {
      "selectedShortCode": _vm.selectedShortCode,
      "shortCodeName": _vm.shortCodeName
    },
    on: {
      "insertShortcodeToText": _vm.insertShortcodeToText,
      "closeAndOpenModals": _vm.closeShortCodeModal,
      "changeSelectedShortCode": _vm.changeSelectedShortCode
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74fc8b63"}!./src/app/pages/message-templates/index/index.html
// module id = 1373
// module chunks = 0